<template>
  <el-dialog
    v-model="isDialogOpen"
    width="30%"
    :before-close="closeDialog"
  >
    <p style="text-align: center;">{{dialogText}}</p>
    <template #footer>
      <el-button @click="closeDialog">OK</el-button>
    </template>
  </el-dialog>
  <div class="scene">
    <div class="hold-screen" v-if="status === 'HOLD'">
      <div class="hold-screen__h">Waiting for Controller to Start Exercise...</div>
    </div>
    <div class="hold-screen" v-if="status === 'CLOSED'">
      <div class="hold-screen__h">
        <h3>Exercise finished</h3>
        <button @click="handleNext"><span style="font-weight: bold;">{{nextBtnTitle}}</span></button>
      </div>
    </div>
    <!--
        <div class="page-container">
            <md-app>
                <md-app-toolbar class="md-primary" md-elevation="0">
                    <span class="md-title">Exercise info</span>
                </md-app-toolbar>

                <md-app-content>
                    <h2>Name: {{socket.name}}</h2>
                    <h2>Code: {{socket.code}}</h2>

                    <h3>{{printPlayTime()}}</h3>
                </md-app-content>
            </md-app>
            <md-app>
                <md-app-toolbar class="md-primary" md-elevation="0">
                    <span class="md-title">Users</span>
                </md-app-toolbar>

                <md-app-content>
                    <div v-for="(user, i) in users">
                        <h3>{{i}}. {{user.name}} ({{user.status}}) - {{user.location}}</h3>
                    </div>
                </md-app-content>
            </md-app>
            <md-app>
                <md-app-toolbar class="md-primary" md-elevation="0">
                    <span class="md-title">Scenario</span>
                </md-app-toolbar>

                <md-app-content>

                    <div v-if="scenario">
                        <h3>Scenario: {{scenario.id}} ({{status}})</h3>
                        <h3>Scenario URL: <a :href="scenario.url">{{scenario.url}}</a></h3>
                        <h3>Location: {{location}}</h3>
                        <h3 v-for="(variable, i) in variables">{{i}}. {{variable}}</h3>
                    </div>

                    <md-button class="md-raised md-primary" @click="onReadyClick">
                        Ready
                    </md-button>

                </md-app-content>
            </md-app>
            <md-app>
                <md-app-toolbar class="md-primary" md-elevation="0">
                    <span class="md-title">Messages</span>
                </md-app-toolbar>

                <md-app-content>

                    <div v-for="msg in messages">
                        [{{msg.time.format('HH:mm:ss')}}] {{msg.from}} -> {{msg.target}}: {{msg.message}}
                    </div>

                    <select v-model="sendMsg.target">
                        <option v-for="user in users" :value="user.id">{{user.name}}</option>
                    </select>

                    <input v-model="sendMsg.text">


                    <md-button class="md-raised md-primary" @click="onSendMsg">
                        Send
                    </md-button>

                </md-app-content>
            </md-app>

        </div>
        -->

    <div class="full-screen" @click="toggleFullscreen">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
<g>
	<g>
		<path style="fill:#010002;" d="M32,26V2H0v24h14v2H8v2h16v-2h-6v-2H32z M2,24V4h28v20H2z"/>
		<polygon style="fill:#010002;" points="28,14 28,6 20,6   "/>
		<polygon style="fill:#010002;" points="4,22 12,22 4,14   "/>
	</g>
</g>
</svg>
    </div>

    <div class="message-box">
      <template v-if="isMessageOpened">
        <input id="messageInput" placeholder="Message..." v-model="sendMsg.text"
              @keyup.enter="onSendMsg"
              @blur="isMessageOpened = !!sendMsg.text">
        <span>to</span>
        <select v-model="sendMsg.target">
          <option v-for="user in users" :value="user.id">{{user.name}}</option>
        </select>
        <button @click="onSendMsg">
          <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 551.13 551.13"
               height="24" viewBox="0 0 551.13 551.13" width="24">
            <path
              d="m0 361.679v-172.228c0-9.52 7.703-17.223 17.223-17.223h258.342v-86.114c0-6.593 3.767-12.614 9.688-15.49 5.937-2.876 12.984-2.119 18.182 1.951l241.119 189.451c4.15 3.26 6.572 8.391 6.576 13.524.004 5.143-2.418 10.288-6.576 13.554l-241.12 189.451c-5.197 4.07-12.244 4.827-18.182 1.951-5.92-2.876-9.688-8.897-9.688-15.49v-86.114h-258.341c-9.52 0-17.223-7.703-17.223-17.223zm34.446-155.005v137.783h258.342c9.52 0 17.223 7.703 17.223 17.223v67.899l196.027-154.013-196.027-154.014v67.899c0 9.52-7.703 17.223-17.223 17.223z"/>
          </svg>
        </button>
      </template>
      <div class="message-trigger" v-else @click="openMessaging">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				     height="20"
					 viewBox="0 0 220.001 220.001" style="enable-background:new 0 0 220.001 220.001;" xml:space="preserve">
					<g>
						<polygon points="0,220 59.34,213.86 6.143,160.661 	"/>
						<path d="M132.018,34.787l53.197,53.197L69.568,203.631L16.37,150.434L132.018,34.787z M212.696,60.502
							c9.738-9.738,9.742-25.527,0-35.268l-17.93-17.93c-9.738-9.74-25.529-9.738-35.268,0l-17.346,17.347l53.199,53.196L212.696,60.502z
							"/>
					</g>
				</svg>
      </div>
      <div class="ping-indicator" :class="[pingColor]"></div>
    </div>

    <div class="terminal" v-if="isTerminalShown">
      <div class="terminal__drawer" ref="terminalDrawerElm">
        <div :class="'terminal__line ' + 'terminal__line--'+line.type" v-for="line in lines">
          <span class="terminal__line-time">{{line.playtime}}</span>
          <span class="terminal__line-text">{{line.text}}</span>
        </div>
      </div>
      <div class="terminal__controls">
        {{printPlayTime()}}

        <button v-if="!isReady" @click="onReadyClick">
          {{ $t('sim.Ready') }}
        </button>

        <select v-model="sendMsg.target">
          <option v-for="user in users" :value="user.id">{{user.name}}</option>
        </select>

        <input v-model="sendMsg.text">


        <button class="md-raised md-primary" @click="onSendMsg">
          {{ $t('messaging.send') }}
        </button>
      </div>
    </div>
    <div id="sim" class="renderer" ref="simElm" :style="!isTerminalShown ? 'width: 100%' : '' "></div>

  </div>
</template>

<script>

  import moment from 'moment';
  import SUSJS from 'susjs-renderer';
  import qs from 'query-string';

  import MSGS from '../serverMessagesTypes';

  const SENT = 'sent';
  const RECEIVE = 'receive';
  const INFO = 'info';
  // import {Toast} from "toaster-js";

  import { ref, computed, watch, onDeactivated } from 'vue';

  export default {

    props: ['socket', 'token', 'host'],

    setup({ socket, token, host }, {emit}) {
      let susjs = null;
      const params = qs.parse(window.location.search);
      const nextBtnTitle = ref(params.nextTitle || (params.nextUrl? "Next Exercise" : "Refresh"));
      const nextBtnUrl = ref(params.nextUrl || null);
      
      console.log({nextBtnTitle, nextBtnUrl, location: window.location});

      const lines = ref([]);
      const status = ref('');
      const scenario = ref({
        id: '',
          url: ''
      });
      const playtime = ref(0);
      const isReady = ref(false);
      const isMessageOpened = ref(false);
      const playStartedAt = ref(null);
      const users = ref([]);
      const location = ref('');
      const variables = ref([]);
      const messages = ref([]);
      const sendMsg = ref({
        target: '',
          text: ''
      });
      const positionChangeIgnore = ref(false);
      let isChangedVarFromServer = true;
      const isRendererIniting = ref(true);

      const terminalPostponeTimeouts = ref({});
      const terminalPostponeTime = ref(100);
      const simElm = ref(null);
      const started_info = ref({});

      if (socket) {
        bindSocketMessages();

        socket.socket.emit('exercise_join', { name: socket.name });
      }

      /////// Fullscreen feature

      const isFullscreen = computed(() => {
        return ((window.fullScreen) || (window.innerWidth == screen.width && window.innerHeight == screen.height));
      });


      function toggleFullscreen() {
        if ((window.fullScreen) ||
          (window.innerWidth == screen.width && window.innerHeight == screen.height)) {
          closeFullscreen();
        } else {
          openFullscreen();
        }
      }

      function openFullscreen() {
        let elem = document.documentElement;
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
          elem.msRequestFullscreen();
        }
      }

      function closeFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE/Edge */
          document.msExitFullscreen();
        }
      }


      let RET_FULLSCREEN = {toggleFullscreen, isFullscreen}

      /////

      function openMessaging() {
        isMessageOpened.value = true;
        setTimeout(() => {
          document.getElementById('messageInput').focus();
        }, 10);
      }

      function bindSocketMessages() {
        socket.on('exercise_join_ok', onExerciseJoinOk);
        socket.on('exercise_join_fail', onExerciseJoinFail);
        socket.on('disconnect', onExerciseDeleteOk);
        socket.on('user_left', onUserLeft);
        socket.on('user_joined', onUserJoined);
        socket.on('user_status_update', onUserStatusUpdate);
        socket.on('exercise_status_update', onExerciseStatusUpdate);
        socket.on('exercise_pause', onExercisePause);
        socket.on('set_var', onSetVar);
        socket.on('user_location_update', onUserLocationUpdate);
        socket.on('text_message', onTextMessage);
        socket.on('play_start', onPlayStart);
        socket.on('play_pause', onPlayPause);

      }

      function printPlayTime() {
        let hrs = Math.floor(playtime.value / 60 / 60 / 1000);
        let mins = Math.floor(playtime.value / 60 / 1000) - hrs * 60;
        let secs = Math.floor(playtime.value / 1000) - mins * 60 - hrs * 60 * 60;

        let format = val => ('0' + val).slice(-2);
        return format(hrs) + ':' + format(mins) + ':' + format(secs);
      }

      function startOrResume() {
        if (susjs) {
          try {
            susjs.resume();
          }
          catch (e) {
          }
        }
        else {
          susjs = new SUSJS(simElm.value, {
            pluginPath: 'lib/susjs-plugins/',
            resolution: 'medium'
          });

          susjs.on('location:enter', onSelfLocationChange);

          susjs.on('simvar:change', onSelfSimvarChange);


          let headers = {
            Accept: 'application/zip, application/octet-stream, application/x-zip-compressed, multipart/x-zip',
          };

          let scenarioUniqueId;
          if (started_info.value.scenario.url.indexOf('/api') === 0 || started_info.value.scenario.url.startsWith("/")) {
            headers.Authorization = token;
            const aPath = started_info.value.scenario.url.split("/archive.zip")[0];
            const split = aPath.split("/");
            scenarioUniqueId = split[split.length - 1];
          }

          // let fetchUrl = started_info.value.scenario.url.indexOf('http') >= 0 ? started_info.value.scenario.url : host + started_info.value.scenario.url;
          let fetchUrl = started_info.value.scenario.url.indexOf('http') >= 0 ? started_info.value.scenario.url : (host + `/api/scenarios/${started_info.value.companyId}/${scenarioUniqueId}/archive`);
          // `/api/scenarios/${this.props.exercise.companyId}/${scenarioUniqueId}/archive`
          return fetch(fetchUrl, {
            method: 'GET',
            headers
          })
            .then(response => {
              return response.blob();
            })
            .then(file => {
              // 04/28/2020: Hayk converted what was previously a timeout of 1sec to wait for promise fulfilliment
              return susjs.loadFromZip(file);
            })
            .then(() => {
              isRendererIniting.value = false;
              // document.querySelector('title').innerHTML = socket.name + ' | ' + scenario.value.title;

            });
        }
      }

      function onExerciseJoinOk(payload) {
        let initialLocation = payload.scenario.locations.find(loc => loc.id === 'initial');
        writeTerminal(`Join Ok ${payload.name}(${payload.code})`, RECEIVE);
        writeTerminal(`Scenario info ${payload.scenario.id} (${payload.scenario.url}) ${initialLocation ? 'initial location - ' + initialLocation.name : 'no initial location'}`, INFO);
        scenario.value.id = payload.scenario.id;
        scenario.value.url = payload.scenario.url;
        scenario.value.title = payload.scenario.title;
        users.value = payload.users.reduce(function (map, obj) {
          map[obj.id] = obj;
          return map;
        }, {});
        sendMsg.value.target = users.value[0];
        status.value = payload.status;
        variables.value = payload.variables;

        started_info.value = payload;
        console.log(payload);

        if (payload.playStartedAt) {
          startOrResume(payload)
            .then(() => {
              if (payload.playStartedAt) {
                onPlayStart({ playTime: payload.playTime });
              }
              else {
                onPlayPause({ playTime: payload.playTime });
              }
            });
        }

        // new Toast('Joined successfully', Toast.TYPE_INFO, Toast.TIME_NORMAL);

        onReadyClick();
      }

      function onSelfLocationChange(location) {
        // console.log({positionChangeIgnore, isRendererIniting})
        if (positionChangeIgnore.value || isRendererIniting.value) {
          positionChangeIgnore.value = false;
          return;
        }
        if (isRendererIniting.value) {
          return;
        }

        let payload = {
          ids: [socket.userId],
          location: location.id.toString(),
        };

        console.log(payload);
        socket.socket.emit(MSGS.USR_MOVE, payload);
        writeTerminal(`Socket sent: location changed: ${location.id}`, SENT);
      }

      function onSelfSimvarChange(simvar) {
        let payload = {
          key: simvar.key,
          value: simvar.val
        };
        
        // console.log("SELF SIM VAR", payload);
        
        if (!isRendererIniting.value) {
          isChangedVarFromServer = false;
          // console.log("sending MSGS.SET_VAR", payload);
          socket.socket.emit(MSGS.SET_VAR, payload);
          writeTerminalPostpone('Socket sent: set var: ', `Socket sent: set var: ${simvar.key} ${simvar.val}`, SENT);
        }

      }

      function onUserLocationUpdate(payload) {
        if (isRendererIniting.value) {
          setTimeout(onUserLocationUpdate, 250, payload);
          return;
        }

        users.value[payload.id].location = payload.location;

        if (payload.id === socket.userId) {
          updateSelfPosition(payload.location);
          writeTerminal(`Socket received: location update ${payload.location}`, RECEIVE);
          // don't show user moves as pop-up
          // this.$toast.default(`Moved to location ${payload.location}`);
        }
      }

      function updateSelfPosition(location) {
        positionChangeIgnore.value = true;
        setTimeout(() => positionChangeIgnore.value = false, 10);
        // console.log("Set Location", location, "variables:", variables.value);
        susjs.setLocation(location);
        // setTimeout(() => {
        //   Object.keys(variables.value).forEach((key) => {
        //     susjs.setSimVar(key, variables.value[key]);
        //   });
        // }, 100)
      }

      function onExerciseJoinFail(payload) {
        alert(payload.message);
        emit('onJoinFail');
      }

      function onExerciseDeleteOk() {
        console.log('disconnect');
        status.value = 'CLOSED';
      }

      function onReadyClick() {
        socket.socket.emit(MSGS.USR_READY);
        isReady.value = true;
        writeTerminal(`Socket sent: ready state`, SENT);
      }

      function onDisconnectClick() {
        socket.disconnect();
        writeTerminal(`Socket disconnected`, INFO);
      }

      function onUserLeft(payload) {
        writeTerminal(`Socket received: user left ${payload.id}`, RECEIVE);
        delete users.value[payload.id];

        // new Toast(`User left ${payload.id}`, Toast.TYPE_MESSAGE, Toast.TIME_NORMAL);
      }

      function onUserJoined(payload) {
        writeTerminal(`Socket received: user joined ${payload.id}`, RECEIVE);
        users.value[payload.id] = payload;
        // new Toast(`User joined ${payload.name}`, Toast.TYPE_MESSAGE, Toast.TIME_NORMAL);
      }

      function onUserStatusUpdate(payload) {
        users.value[payload.id].status = payload.status;
      }

      function onExerciseStatusUpdate(payload) {
        status.value = payload;
      }

      function onExercisePause(payload) {
        console.log('onExercisePause', payload);
      }

      function onSetVar(payload) {
        // console.log("onSetVar", isChangedVarFromServer, payload);
        if (isChangedVarFromServer) {
          writeTerminalPostpone('Socket received: set var: ', `Socket received: set var: ${payload.key} ${payload.value}`, RECEIVE);
          variables.value[payload.key] = payload.value;
          susjs.setSimVar(payload.key, payload.value);
        }
        isChangedVarFromServer = true;
      }

      let runningTimer = null;
      function onPlayStart(payload) {
        writeTerminal(`Socket received: sim started`, RECEIVE);
        playStartedAt.value = new Date();
        startOrResume(payload);
        runningTimer = setInterval(
          () => playtime.value = payload.playTime + new Date().getTime() - playStartedAt.value.getTime(),
          500);
        // new Toast('Exercise started', Toast.TYPE_DONE, Toast.TIME_NORMAL);
      }

      function onPlayPause(payload) {
        writeTerminal(`Socket received: sim paused`, RECEIVE);
        playtime.value = payload.playTime;
        try {
          susjs.pause();
        }
        catch (e) {
        }
        clearInterval(runningTimer);
        // new Toast('Exercise paused', Toast.TYPE_WARNING, Toast.TIME_NORMAL);
      }

      function onTextMessage(payload) {
        writeTerminal(`Socket received: message receive from ${payload.from}: ${payload.message}`, RECEIVE);
        let user = users.value[payload.from];
        messages.value.push({
          from: user.name,
          target: payload.target && user.name,
          message: payload.message,
          time: moment()
        });
        if (socket.userId !== user.id) {
          let userName = (user.type == "ORGANIZER" ? "" : user.name + ": " );
          // let newToast = new Toast(`${userName}${payload.message}`, Toast.TYPE_DONE, Number.MAX_SAFE_INTEGER);
          if(!payload.options || !payload.options.preventWebClientPopup) {
            handleShowDialog(`${userName}${payload.message}`)
          }
        }
      }

      function onSendMsg() {
        socket.sendTextMessage(sendMsg.value.target, sendMsg.value.text);
        writeTerminal(`Socket sent: message sent to ${sendMsg.value.target}: ${sendMsg.value.text}`, SENT);
        sendMsg.value.text = '';
        sendMsg.value.target = '';
        isMessageOpened.value = false;
      }



      const isTerminalShown = computed(() => {
        if (window) {
          if (window.location.search.indexOf('debug') >= 0) {
            return true;
          }
        }
        return false;
      });

      const terminalDrawerElm = ref(null);

      function writeTerminal(text, type) {
        lines.value.push({ type, text, time: new moment(), playtime: printPlayTime() });
        setTimeout(() => {
          if (isTerminalShown) {
            terminalDrawerElm.scrollTop = 100000;
          }
        }, 50);
      }

      function writeTerminalPostpone(name, text, type) {
        clearTimeout(terminalPostponeTimeouts.value[name]);

        terminalPostponeTimeouts.value[name] = setTimeout(writeTerminal.bind({}, text, type), terminalPostponeTime.value);
      }
      
      // message dialog properties
      
      const dialogText = ref("");
      const isDialogOpen = ref(false);

      function handleShowDialog (text) {
        console.log("Received at handle show dialog with text:", text)
        dialogText.value = text;
        isDialogOpen.value = true;
      };
      function closeDialog () {
        isDialogOpen.value = false;
        dialogText.value = "";
      };
      
      function handleNext() {
        if(nextBtnUrl.value) {
          return window.location.href = nextBtnUrl.value;
        }
        return window.location.assign(window.location.href)
      }
      
      // ping test properties
      const GREEN = 'green-bg';
      const YELLOW = 'yellow-bg';
      const RED = 'red-bg';
      const pingColor = ref(GREEN);
      
      setInterval(() => {
        const timer = new Date();
        fetch('/')
        .then(()=>{
          const now = new Date();
          const diff = now - timer;
          if(diff < 200) {
            return pingColor.value = GREEN;
          }
          if(diff < 500) {
            return pingColor.value = YELLOW;
          }
          return pingColor.value = RED;
        })
        .catch(console.error)
      }, 5000)
      
      
      return {
        simElm, terminalDrawerElm, isTerminalShown, isMessageOpened, sendMsg, status, users, onSendMsg, openMessaging, ...RET_FULLSCREEN,
        dialogText, isDialogOpen, handleShowDialog, closeDialog, handleNext, nextBtnTitle, nextBtnUrl,
        pingColor
      }
    },

    methods: {
    }
  };


</script>
<style lang="scss">
  @import "../defs";
  
  .green-bg {
    background: green !important;
  }
  
  .yellow-bg {
    background: yellow !important;
  }
  
  .red-bg {
    background: red !important;
  }

  .hold-screen {
    background: rgba(#000, .99);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 10000;

    &__h {
      font-size: 32px;
      font-weight: bold;
      color: #fff;
      text-align: center;
    }
  }

  .scene {
    display: flex;
    flex-direction: row;
    height: 100vh;
    align-items: stretch;
    justify-content: stretch;
    width: 100vw;
    position: relative;
  }
  
  .ping-indicator {
    width: 2em;
    height: 2em;
    border-radius: 50%;
    margin-left: 5px;
  }

  .message-trigger {
    height: 2rem;
    width: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    border-radius: 5px;
    margin-left: 1rem;
    background: $--color-primary;
    opacity: .8;
    cursor: pointer;
    transition: .2s;
    outline: none;

    svg * {
      /*fill: #fff;*/
    }

    &:hover {
      opacity: 1;
    }
  }

  .message-box {
    position: absolute;
    z-index: 1053;
    bottom: 4em;
    right: 2em;
    display: flex;
    align-items: center;
    flex-direction: row;

    input,
    select {
      height: 2rem;
      width: 400px;
      border: none;
      border-radius: 5px;
      padding: 0 1rem;
      line-height: 2rem;
      outline: none;
      background: rgba(#fff, .5);
      transition: .2s;
      font-size: 1.2rem;

      &:focus {
        background: #fff;
      }
    }

    span {
      margin-left: 1rem;
      color: #fff;
    }

    select {
      width: auto;
      margin-left: 1rem;
    }

    button {
      height: 2rem;
      width: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      border-radius: 5px;
      margin-left: 1rem;
      background: $--color-primary;
      opacity: .8;
      cursor: pointer;
      transition: .2s;
      outline: none;

      svg * {
        /*fill: #fff;*/
      }

      &:hover {
        opacity: 1;
      }
    }
  }

  .notices.is-bottom {
    bottom: 5em;
  }

  .terminal {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    background: #000;
    color: #cccccc;
    width: 100%;
    min-width: 500px;
    flex-shrink: 1000;
    font-family: monospace;

    &__drawer {
      height: 100%;
      flex-shrink: 10;
      overflow: auto;
    }

    &__controls {
      padding: 10px;
    }

    &__line {
      display: flex;
      flex-direction: row;
      width: 100%;
      align-items: stretch;
      justify-content: stretch;
      line-height: 1.2;
      margin: 3px 0;

      &--error {

      }

      &--sent {
        color: #007200
      }
      &--receive {
        color: #8b8b00
      }
      &--info {
        color: #3f5bad
      }

      &-text {

      }

      &-time {

        margin-right: 10px;
        color: #777;
      }

    }
  }

  .full-screen {
    position: absolute;
    top: 20px;
    left: 20px;
    min-width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem;
    width: 2rem;
    background: #aaa;
    border-radius: 5px;
    z-index: 100;
    cursor: pointer;
    opacity: .8;
    transition: .2s;

    &:hover {
      opacity: 1;
    }
  }

  .renderer {
    background: #000000;
    height: 100%;
    position: relative;
    width: 134vh;
  }
</style>
